import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router';
import { Helmet } from 'react-helmet';
import EmptyList from '../components/EmptyList';
import { SportsData } from '../data/SportsData';
import ImageSlider from '../components/ImageSlider';

function MyList({ items }) {
    return (
        <div className="para-content">
            <ol>
                {items.map((item, index) => (
                    <li key={index}>{item}</li>
                ))}
            </ol>

        </div>

    );
}

function createTable(achievements) {
    return (
        <table className='sports-achievements-table'>
            <thead>
                <tr>
                    <th >Awards</th>
                    <th>Sports-person</th>
                    <th>Year</th>
                </tr>
            </thead>
            <tbody>
                {achievements.map((achievement, index) => (
                    <tr key={index}>
                        <td>{achievement.Awards}</td>
                        <td>{achievement["Sports-person"]}</td>
                        <td>{achievement.Year}</td>
                    </tr>
                ))}
            </tbody>
        </table>
    );
}


const SportsDetails = () => {
    const { SportsName } = useParams();
    const [Sport, setSport] = useState(null);
    useEffect(() => {
        let Sport = SportsData.find((Sport) => Sport.SportsName === (SportsName));
        if (Sport) {
            setSport(Sport);
        }
    }, [SportsName]);
    return (
        <div className='main-container'>
            {Sport ? (
                <div>
                    <Helmet>
                        <title>Sports | {Sport.SportsName}</title>
                    </Helmet>

                    <div className="section">
                        <div className="section-heading">
                            <h1>{Sport.SportsName}</h1>
                        </div>
                        <div className="grid-2">
                            <div className="sports-details">
                                <p>{Sport.Para1}</p><br />
                                <p>{Sport.Para2}</p>
                                {Sport.Para3 &&
                                    <p>{Sport.Para3}</p>
                                }
                                {Sport.GameRules.length === 0 ? (
                                    <></>
                                ) : (
                                    <div className='sports-details'>
                                        <h2>
                                            Game Rules
                                        </h2>
                                        <MyList items={Sport.GameRules} />

                                    </div>
                                )}
                            </div>

                            <div className="sports-page-img">
                                {/* <img src={Sport.CardImage} alt='' /> */}
                                <ImageSlider images={Sport.Images} />
                            </div>

                        </div>






                        {Sport.Achievements.length === 0 ? (
                            <></>
                        ) : (
                            <div className='sports-achievements'>
                                <h2>
                                    Achievements
                                </h2>
                                {createTable(Sport.Achievements)}

                            </div>
                        )}


                    </div>
                </div>



            ) : (
                <EmptyList />
            )}
        </div>
    )
}

export default SportsDetails